import { Routes } from '@angular/router';

export const appRoutes: Routes = [
	//{ path: 'app', loadChildren: '../../mainModule/appMain.module#AppMainModule' },
	{ path: 'app/teamplus/:token', loadChildren: './teamplus/teamplus.module#TeamplusModule' },
	{ path: 'app/teamplus', loadChildren: './teamplus/teamplus.module#TeamplusModule' },
	// { path: 'app/register', loadChildren: './login/login.module#LoginModule' },
	// { path: 'auth/action', loadChildren: './login/login.module#LoginModule' },
	// { path: 'app/game/:c/:d/:e/:f/:g', loadChildren: './login/login.module#LoginModule' },
	// { path: 'app/game/:c/:d/:e/:f', loadChildren: './login/login.module#LoginModule' },
	// { path: 'app/game/:c/:d/:e', loadChildren: './login/login.module#LoginModule' },
	// { path: 'app/game/:c/:d', loadChildren: './login/login.module#LoginModule' },
	// { path: 'app/game/:c', loadChildren: './login/login.module#LoginModule' },
	// { path: 'app/game', loadChildren: './login/login.module#LoginModule' },
	// { path: '', redirectTo: 'app/game', pathMatch: 'full' },
	
	//{ path: '', loadChildren: './login/login.module#LoginModule' },
	
	
]



// WEBPACK FOOTER //
// ./src/app/app.routes.ts